<form [formGroup]="form" class="px-24">
  <icz-section label="Datum uzavření">
    <icz-date-picker class="grow" label="Datum uzavření" formControlName="closeDate" outputFormat="dateTime"></icz-date-picker>
  </icz-section>
  <icz-section label="Přenastavit hromadně pro všechny uzavírané spisy">
    <icz-checkbox label="Pro všechny vyřizované spisy přenastavit věcnou skupinu nebo typ spisu"
                  formControlName="useGlobalSettings" class="mb-16"></icz-checkbox>
    @if (form.get('useGlobalSettings')!.value) {
      <div class="row grow">
        <div class="col grow">
          <icz-form-autocomplete
            label="Typ spisu"
            formControlName="fileTypeId"
            [options]="fileTypeOptions"
          ></icz-form-autocomplete>
          <icz-entity-class-selector
            [form]="form"
            controlName="entityClassId"
            [showEntityClassesValidAt]="closeDate"
            [usage]="EntityClassSelectorUsage.OFFICER_CURRENT_WITH_V"
            [selectorEntityClassType]="EntityClassType.DOCUMENT_FILE"
          ></icz-entity-class-selector>
          @if (entityClassId) {
            <div class="row-8 grow">
              <icz-date-picker label="Platnost věcné skupiny od" formControlName="entityClassValidFrom" class="grow" outputFormat="dateTime" placeholder="Neomezeno"></icz-date-picker>
              <icz-date-picker label="Platnost věcné skupiny do" formControlName="entityClassValidTo" class="grow" outputFormat="dateTime" placeholder="Neomezeno"></icz-date-picker>
            </div>
          }
          <icz-section label="Skartační režim">
            <div class="col grow">
              <icz-form-field formControlName="disposalOperationCode" label="Výsledný skartační znak"></icz-form-field>
              <icz-form-field formControlName="disposalYear" label="Předpokládaný rok vyřazení"></icz-form-field>
              <icz-form-autocomplete
                [clearable]="false"
                [options]="retentionTriggerTypesOptions"
                class="grow"
                formControlName="retentionTriggerTypeCode"
                label="Spouštěcí událost"
              ></icz-form-autocomplete>
              @if (isExternalRetentionTriggerTypeWithPeriod()) {
                <icz-ext-retention-trigger-selector
                  [form]="form"
                  [availableExternalRetentionTriggerIds]="form.get('externalRetentionTriggerIds')!.value ?? []"
                ></icz-ext-retention-trigger-selector>
              }
            </div>
            <div class="col grow">
              @if (isRetentionTriggerTypeWithPeriod()) {
                <div class="row">
                  <icz-form-field class="grow" label="Rok spouštěcí události"  formControlName="yearOfRetentionPeriodStart" type="integer"></icz-form-field>
                  <icz-form-field class="grow" label="Rok kontroly spouštěcí události"  formControlName="triggerEventCheckYear" type="integer"></icz-form-field>
                </div>
              }
            </div>
          </icz-section>
        </div>
      </div>
    }
  </icz-section>
</form>
